export default "__VITE_ASSET__e9681981__"